module.exports = __webpack_public_path__ + "static/img/wx_share_img.699cfd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wx_share_img.png
// module id = 184
// module chunks = 1